import moment from 'moment';

type DeliveryDate = string | Date | null | undefined;

type DefaultCalendarMonthParams = {
  calendarInitDate?: DeliveryDate;
  firstDeliveryDate?: DeliveryDate;
  lastDeliveryDate?: DeliveryDate;
};

const getDefaultCalendarMonth = (
  {
    calendarInitDate,
    firstDeliveryDate,
    lastDeliveryDate,
  }: DefaultCalendarMonthParams,
  now: Date = new Date()
): Date => {
  if (calendarInitDate) {
    return new Date(calendarInitDate);
  }

  // A diet without any delivery date (e.g. all bags removed) would otherwise open on January 1970.
  if (!lastDeliveryDate) {
    return now;
  }

  if (
    moment(now).isBetween(moment(firstDeliveryDate), moment(lastDeliveryDate))
  ) {
    return now;
  }

  return new Date(lastDeliveryDate);
};

export default getDefaultCalendarMonth;
